import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt, faChartLine, faFire } from '@fortawesome/free-solid-svg-icons'

class TopRank extends React.Component {
  render() {
    return (
      <>
        <p className='text-center message'><b><FontAwesomeIcon className="mr-1" icon={faChartLine} />Ranked as Top Online Bootcamps 2023</b></p>

        <p className='text-center message'>
          <a href="https://www.forbes.com/advisor/education/best-coding-bootcamps/" className="text-dark mr-1" style={{textDecoration: 'none'}} target="_blank">
            <img src='/forbes-logo-min-2023.png' style={{height: "1rem",verticalAlign: "-1px"}} />
          </a>
          <b style={{display: 'inline-block', verticalAlign: 'middle', lineHeight: 'normal'}}> Best Coding Bootcamps 2023</b>
        </p>
      </>
    );
  }
}

export default TopRank;
